import React from 'react';
import './Loader.css'; // Import the CSS file

const Loader = () => {
  return <div className="loader"></div>;
};

export default Loader;
